import { config } from "../config";
import { getAuthToken } from "../util/auth";

export const getMailboxesApi = async () => {
    const response = await fetch(`${config.url}/mailboxes/mailboxes`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Fetching mailboxes faild');
    }

    const resData = await response.json();
    return resData;
}

export const getEmailsListApi = async (mailboxId, folder, tag) => {
    let url = `${config.url}/mailboxes/mailbox-emails-list/${mailboxId}/${folder}`;
    if (tag) {
        url += `?tag=${tag}`;
    }
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Fetching Emails list faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateEmailStarredApi = async (mailId, newValue) => {
    const response = await fetch(`${config.url}/mailboxes/update-email-starred/${mailId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ value: newValue })
    });

    if (!response.ok) {
        throw new Error('Update email starred faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateEmailImportantApi = async (mailId, newValue) => {
    const response = await fetch(`${config.url}/mailboxes/update-email-important/${mailId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ value: newValue })
    });

    if (!response.ok) {
        throw new Error('Update email important faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateEmailsStarredApi = async (emailsIds, value) => {
    const response = await fetch(`${config.url}/mailboxes/update-emails-starred`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ emailsIds, value })
    });

    if (!response.ok) {
        throw new Error('Update emails starred faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateEmailsImportantApi = async (emailsIds, value) => {
    const response = await fetch(`${config.url}/mailboxes/update-emails-important`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ emailsIds, value })
    });

    if (!response.ok) {
        throw new Error('Update emails important faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateEmailsLabelApi = async (emailsIds, value) => {
    const response = await fetch(`${config.url}/mailboxes/update-emails-label`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ emailsIds, value })
    });

    if (!response.ok) {
        throw new Error('Update emails label faild');
    }

    const resData = await response.json();
    return resData;
}

export const moveEmailsToFolderApi = async (emailsIds, folder) => {
    const response = await fetch(`${config.url}/mailboxes/move-emails-to-folder`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ emailsIds, folder })
    });

    if (!response.ok) {
        throw new Error('Move emails to folder faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateEmailsIsReadApi = async (emailsIds, value) => {
    const response = await fetch(`${config.url}/mailboxes/update-emails-is-read`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ emailsIds, value })
    });

    if (!response.ok) {
        throw new Error('Update emails is read faild');
    }

    const resData = await response.json();
    return resData;
}

export const sendMailApi = async (from, to, cc, bcc, subject, mailFiles, htmlContent, textContent) => {
    const response = await fetch(`${config.url}/mailboxes/send-mail`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ from, to, cc, bcc, subject, mailFiles, htmlContent, textContent })
    });

    if (!response.ok) {
        throw new Error('Sending mail faild');
    }

    const resData = await response.json();
    return resData;
}

export const createNewLabelApi = async (label, activeMailbox) => {
    const response = await fetch(`${config.url}/mailboxes/create-new-label`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ label, activeMailbox })
    });

    if (!response.ok) {
        throw new Error('Create new label faild');
    }

    const resData = await response.json();
    return resData;
}